export default __webpack_public_path__ + "static/media/babycare.09a4f49b.jpeg";